module.exports = __webpack_public_path__ + "img/logo-light.947a861f.png";